import * as yup from 'yup';


export const atsFormSchema = yup.object({
});
